/* eslint-disable @typescript-eslint/ban-types */
export function isObject(value) {
    return value !== null && typeof value === 'object';
}
export function assertIsObject(value) {
    if (!isObject(value)) {
        throw new TypeError(`Value is not of type object.`);
    }
}
//# sourceMappingURL=object.js.map